
import './services/base-control.service';
import './directives/angular-signature.directive';
import './directives/angular-custom-masks.directive';

import BaseControlService from './services/base-control.service';
import TypeFormatService from './services/type-format.service';
import DateControlComponent from './controls/date-control/date-control.component';
import DatetimeControlComponent from './controls/datetime-control/datetime-control.component';
import TimeControlComponent from './controls/time-control/time-control.component';
// import DurationControlComponent from './controls/duration-control/duration-control.component';
import NumericControlComponent from './controls/numeric-control/numeric-control.component';
import MultiselectControlComponent from './controls/multiselect-control/multiselect-control.component';
import RatingControlComponent from './controls/rating-control/rating-control.component';
import PercentControlComponent from './controls/percent-control/percent-control.component';
import CurrencyControlComponent from './controls/currency-control/currency-control.component';
import SelectControlComponent from './controls/select-control/select-control.component';
import TextareaControlComponent from './controls/textarea-control/textarea-control.component';
import PhoneControlComponent from './controls/phone-control/phone-control.component';
import EmailControlComponent from './controls/email-control/email-control.component';
import UrlControlComponent from './controls/url-control/url-control.component';
import FileControlComponent from './controls/file-control/file-control.component';
import ImageControlComponent from './controls/image-control/image-control.component';
import SignatureControlComponent from './controls/signature-control/signature-control.component';
import RecordIdControlComponent from './controls/recordid-control/recordid-control.component';
import FEControlComponent from './fe-control/fe-control.component';
import ReportControlComponent from './controls/report-control/report-control.component';
import TextControlComponent from './controls/text-control/text-control.component';
import RichtextControlComponent from './controls/richtext-control/richtext-control.component';
import EmbedHtmlControlComponent from './controls/embed-html-control/embed-html-control.component';
import CheckboxControlComponent from './controls/checkbox-control/checkbox-control.component';
import MultiCheckBoxControlCtrlComponent from './controls/multicheckbox-control/multicheckbox-control.component';
import RadioControlComponent from './controls/radio-control/radio-control.component';
import SearchSelectControlComponent from './controls/search-select-control/search-select-control.component';
import NotFoundComponent from './controls/not-found/not-found.component';
import FormatFunctionsConstant from './constants/format-functions.constant';
// import SearchSelectModal from './modals/search-select/search-select.component';
import FileUploadModal from './modals/file-upload/file-upload.component';
import SignatureModal from './modals/signature/signature.component';
import FontSignature from './modals/signature/font-signature/font-signature.component';

const DEPENDENCIES = [
  'signature', 'customMasks'
];

angular
  .module('fe-control', DEPENDENCIES)
  .service('BaseControlService', BaseControlService)
  .service('TypeFormatService', TypeFormatService)
  .constant('FORMAT_FUNCTIONS', FormatFunctionsConstant)
  .directive('resetOnEmptyString', function() {
    return {
      require: 'ngModel',
      link: function (_s, _e, _a, ngModel) {
        ngModel.$formatters.push(val => (val === '') ? undefined : val);
      }
    };
  })
  .component('feControl', FEControlComponent)
  .component('dateControl', DateControlComponent)
  .component('timeControl', TimeControlComponent)
  .component('datetimeControl', DatetimeControlComponent)
  // .component('durationControl', DurationControlComponent)
  .component('reportControl', ReportControlComponent)
  .component('notFound', NotFoundComponent)
  .component('textControl', TextControlComponent)
  .component('richtextControl', RichtextControlComponent)
  .component('embedHtmlControl', EmbedHtmlControlComponent)
  .component('checkboxControl', CheckboxControlComponent)
  .component('multicheckboxControl', MultiCheckBoxControlCtrlComponent)
  .component('emailControl', EmailControlComponent)
  .component('phoneControl', PhoneControlComponent)
  .component('textareaControl', TextareaControlComponent)
  .component('selectControl', SelectControlComponent)
  .component('currencyControl', CurrencyControlComponent)
  .component('percentControl', PercentControlComponent)
  .component('ratingControl', RatingControlComponent)
  .component('multiselectControl', MultiselectControlComponent)
  .component('urlControl', UrlControlComponent)
  .component('fileControl', FileControlComponent)
  .component('imageControl', ImageControlComponent)
  .component('signatureControl', SignatureControlComponent)
  .component('searchSelectControl', SearchSelectControlComponent)
  // .component('searchSelectModal', SearchSelectModal)
  .component('fileUploadModal', FileUploadModal)
  .component('signatureModal', SignatureModal)
  .component('fontSignature', FontSignature)
  .component('numericControl', NumericControlComponent)
  .component('radioControl', RadioControlComponent)
  .component('recordidControl', RecordIdControlComponent)
